module.exports = __webpack_public_path__ + "static/img/icon_hr.b3e66d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon_hr.png
// module id = 2994
// module chunks = 1